import { Component, SimpleChanges, OnChanges } from '@angular/core';

import { HotkeysService, Hotkey } from '@ngneat/hotkeys';
import { VbNestedMenuComponent } from '../shared/VbNestedMenuComponent';

@Component({
	selector: 'vb-hotkeys-help',
	host: {
		class: 'submenuWrap'
	},
	template: `
		<div
			class="dropdown"
			dropdown
			#dropdown="bs-dropdown"
			[autoClose]="true"
			[insideClick]="false"
			placement="top right"
			[dropup]="true">
			<ul
				class="dropdown-menu dropdownMenu playerSettingsMenu"
				*dropdownMenu
				#vbDropdownMenu
				aria-labelledby="buttonMenuHotkeys"
				id="dropdownHotkeysMenu"
				role="menu"
				tabindex="0">
				<li role="none" class="menuHeading">
					<button type="button"
						role="menuitem"
						class="dropdown-item btn-link backToMainMenuItem"
						(click)="hideMenu()">
						<span>{{ translations.keyboardShortcuts }}</span>
					</button>
				</li>

				@for (key of hotkeys; track key) {
					<li role="none">
						@if (key.description) {
							<button type="button"
								role="menuitem"
								class="dropdown-item btn-link readonly">
								<span>{{ key.description }}</span>
							</button>
						}
					</li>
				}
			</ul>
		</div>
	`,
	standalone: false,
	styleUrls: ['../VbPlayerSettingsMenu.Component.ng.less', '../MenuButton.ng.less']
})
export class VbHotkeysHelpComponent extends VbNestedMenuComponent implements OnChanges {
	public hotkeys: Hotkey[];

	constructor(
		private HotkeysService: HotkeysService
	){
		super();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		super.ngOnChanges(changes);

		if (changes.activateDropdown && this.activateDropdown) {
			this.assignHotKeys();
		}
	}

	public assignHotKeys(): void {
		this.hotkeys = this.HotkeysService.getHotkeys()
			.filter(hotkey => hotkey.description)
			.sort((a, b) => a.description.localeCompare(b.description));
	}
}
